// extracted by mini-css-extract-plugin
module.exports = {"PageFoundersBlock__title":"PageFoundersBlock_PageFoundersBlock__title__HzRo2","PageFoundersBlock__cards":"PageFoundersBlock_PageFoundersBlock__cards__Jn7hU"};